import axios from "./axios-handler.service";
const BASE_URL = "/api/Promocao";

export interface Promocao {
  idPromocao?: number;
  nome: string;
  dataInicial: string;
  dataFinal: string;
  status: number;
  regulamento: string;
}

export interface Premio {
  colocacao: number;
  descricao: string;
  idPremioPromocao: number;
  idPromocao: number;
  imagem: string;
  nome: string;
  promocao: Promocao;
}

export enum StatusPromocao {
  Ativa = "Ativa",
  Programada = "Programada",
  Inativa = "Inativa",
  Finalizada = "Finalizada",
  Null = "Null",
}

export class PromocaoService {
  static async Lista(status: StatusPromocao) {
    const response = await axios.get<Promocao[]>(`${BASE_URL}/Lista`, {
      params: { status },
    });
    return response.data;
  }

  static async ListarStatusPromocao(): Promise<any> {
    const response = await axios.get<Promise<any>>(
      BASE_URL + "/ListarStatusPromocao"
    );
    return response.data;
  }

  static async manterPromocao(promocao: Promocao): Promise<string> {
    const response = await axios.post<string>(BASE_URL + "/Manter", promocao);
    return response.data;
  }

  static async ExcluirPromocao(id: number): Promise<void> {
    const response = await axios.delete(`${BASE_URL}/ExcluirPromocao`, {
      params: { id },
    });
    return response.data;
  }

  static async Manter(idPromocao: number): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/Manter`, {
      params: { idPromocao },
    });
    return response.data;
  }

  static async ObterUrlPromocao(): Promise<string> {
    const response = await axios.get<string>(`${BASE_URL}/ObterUrlPromocao`);
    return response.data;
  }

  static async UploadImagemPremio(arquivo: string) {
    const response = await axios.post(BASE_URL + "/UploadImagemPremio", {
      arquivo,
    });
    return response.data;
  }

  static async PopPremio(
    idPromocao: number,
    idPremioPromocao: number | null
  ): Promise<Premio> {
    const response = await axios.get<Promise<Premio>>(`${BASE_URL}/PopPremio`, {
      params: { idPromocao, idPremioPromocao },
    });
    return response.data;
  }

  static async SalvarPremio(premioPromocao: Premio) {
    const response = await axios.post(
      BASE_URL + "/SalvarPremio",
      premioPromocao
    );
    return response.data;
  }

  static async ExcluirPremio(idPremioPromocao: number) {
    const response = await axios.post(BASE_URL + "/ExcluirPremio", {
      idPremioPromocao,
    });
    return response.data;
  }

  static async ObterUrlImagemPremio(): Promise<string> {
    const response = await axios.get<Promise<string>>(
      `${BASE_URL}/ObterUrlImagemPremio`
    );
    return response.data;
  }
}
